// Dependencies
import { createContext } from 'react';

const MobileMenuContext = createContext({
  isOpen: false,
});

export default MobileMenuContext;
